import { get, IHttpRequestConfig, post } from "@/browser";
import { extractDataFromResponse } from "@/core/api";
import { compose, IURLPageConfig, IURLParams, IURLSearchParams } from "@/core/url";

import { ICreateSkillDto, IPartialPageableSkill, ISkill, pageableSkillType, skillType } from "./types";

const API = {
  list: "/api/public/skills",
  one: "/api/public/skills/list",
  create: "/api/skills",
  suggestedList: "/api/suggested-skills",
};

export interface IFetchSkillsListParams extends IURLSearchParams, IURLParams {
  query: string;
}

export const fetchSkillsList = (params?: IFetchSkillsListParams, options?: IHttpRequestConfig) => {
  const url = compose(API.list, {}, params);
  return get<IPartialPageableSkill>(url, options).then(extractDataFromResponse).then(pageableSkillType);
};

export const getSkillById = (skillId: number[], options?: IHttpRequestConfig) => {
  const url = compose(API.one, {}, { skillId });
  return get<ISkill[]>(url, options).then(extractDataFromResponse);
};

export interface IPostSkillParams {}

export const postSkill = (params: IPostSkillParams, data: ICreateSkillDto, options?: IHttpRequestConfig) => {
  const url = compose(API.create, {}, params);

  return post<ISkill>(url, data, options).then(extractDataFromResponse).then(skillType);
};

export interface IFetchSuggestedSkillsParams extends Partial<IURLPageConfig> {
  skillRoleId?: number;
  cvIds?: number[];
}

export const fetchSuggestedSkillsList = (params: IFetchSuggestedSkillsParams, options?: IHttpRequestConfig) => {
  const url = compose(API.suggestedList, {}, params);
  return get<IPartialPageableSkill>(url, options).then(extractDataFromResponse).then(pageableSkillType);
};
